import { FormProvider, useForm } from "react-hook-form";
import { defaultReturnRequest, ReturnRequest } from "./types.ts";
import { useEffect, useState } from "react";
import { useReturnRequestApi } from "../../hooks/useReturnRequestApi.ts";
import { Alert, Box, CircularProgress, Stack } from "@mui/material";
import ReturnRequestTable from "./ReturnRequestTable.tsx";
import ConsoleHeader, {
  ConsoleHeaderMeta,
  LedgerFrame,
} from "../../components/common/ConsoleHeader.tsx";
import { designTokens } from "../../theme.ts";

export default function ReturnRequestMonitor() {
  const methods = useForm<ReturnRequest>({ defaultValues: defaultReturnRequest });
  const [data, setData] = useState<ReturnRequest[]>();
  const [error, setError] = useState<string>();
  const { getAllReturnRequest } = useReturnRequestApi();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const json = await getAllReturnRequest();
        if (!cancelled) setData(json);
      } catch (e: any) {
        if (!cancelled) setError(e.message ?? String(e));
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const total = data?.length ?? 0;

  return (
    <Box sx={{ fontFamily: designTokens.fonts.sans }}>
      <ConsoleHeader
        code="MARS · RETURN · MONITOR"
        title="반품 모니터"
        meta={<ConsoleHeaderMeta recordCountLabel="회수요청" count={total} />}
      />

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {!data && !error && (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, py: 8 }}>
          <CircularProgress size={28} sx={{ color: designTokens.cargo }} />
          <Box sx={{ fontFamily: designTokens.fonts.sans, fontSize: 14, color: "#6B7178" }}>
            회수요청 목록을 불러오는 중입니다…
          </Box>
        </Box>
      )}

      {data && (
        <FormProvider {...methods}>
          <LedgerFrame label="회수요청 목록" rows={total}>
            <Stack>
              <ReturnRequestTable data={data} isLoading={false} />
            </Stack>
          </LedgerFrame>
        </FormProvider>
      )}
    </Box>
  );
}
